var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("group.editModal.externalUsers.editModal.title")
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.user
              ? _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: _vm.uid + "_firstname" } }, [
                      _vm._v(_vm._s(_vm.$t("firstname")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.firstName,
                          expression: "user.firstName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: _vm.uid + "_firstname", type: "text" },
                      domProps: { value: _vm.user.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.user, "firstName", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: _vm.uid + "_lastname" } }, [
                      _vm._v(_vm._s(_vm.$t("lastname")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.lastName,
                          expression: "user.lastName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: _vm.uid + "_lastname", type: "text" },
                      domProps: { value: _vm.user.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.user, "lastName", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: _vm.uid + "_email" } }, [
                      _vm._v(_vm._s(_vm.$t("email")))
                    ]),
                    _vm._v(" "),
                    !_vm.noEmail
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.email,
                              expression: "user.email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: _vm.uid + "_email", type: "text" },
                          domProps: { value: _vm.user.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.user, "email", $event.target.value)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowNoEmailForExternalUsers
                      ? _c("div", { staticClass: "form-group form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.noEmail,
                                expression: "noEmail"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              id: _vm.uid + "_email_nomail",
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.noEmail)
                                ? _vm._i(_vm.noEmail, null) > -1
                                : _vm.noEmail
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.noEmail,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.noEmail = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.noEmail = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.noEmail = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: _vm.uid + "_email_nomail" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "group.editModal.externalUsers.editModal.noEmail"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: _vm.uid + "_company" } }, [
                      _vm._v(_vm._s(_vm.$t("company")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.company,
                          expression: "user.company"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: _vm.uid + "_company", type: "text" },
                      domProps: { value: _vm.user.company },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.user, "company", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: _vm.uid + "_salutation" } }, [
                        _vm._v(_vm._s(_vm.$t("salutation")))
                      ]),
                      _vm._v(" "),
                      _c("vSelect", {
                        attrs: {
                          id: _vm.uid + "_salutation",
                          options: _vm.availableSalutations,
                          taggable: true,
                          appendToBody: true,
                          "calculate-position": _vm.vSelectInModalWithPopper
                        },
                        model: {
                          value: _vm.user.salutation,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "salutation", $$v)
                          },
                          expression: "user.salutation"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.hideDisabled
                    ? _c("div", { staticClass: "form-group form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.disabled,
                              expression: "user.disabled"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            id: _vm.uid + "_disabled",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.user.disabled)
                              ? _vm._i(_vm.user.disabled, null) > -1
                              : _vm.user.disabled
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.user.disabled,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.user,
                                      "disabled",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.user,
                                      "disabled",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.user, "disabled", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: _vm.uid + "_disabled" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("group.groupUserExternal.model.disabled")
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { staticClass: "form-check-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("group.groupUserExternal.model.media"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("ExternalUserImageEditor", {
                        attrs: { externalUser: _vm.user }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("save", _vm.user)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("general.apply")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }